<template>
    <div id="app">
        <keep-alive include="Map, Panorama">
            <router-view />
        </keep-alive>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'app',

    methods: {
        ...mapActions('permissions', ['fetchPermissions']),
    },

    created() {
        this.fetchPermissions();
    },
};
</script>
